<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <div id="app" v-if="!isMobile">
    <commonHeaderPc></commonHeaderPc>
    <router-view style="padding-top:120px"/> <!-- 路由内容将在这里渲染 -->
    <commonFooterPc></commonFooterPc>
    <el-backtop :bottom="70" :right="70" style="width:51px;height:50px">
      <div
        style="{
          background-color: rgba(0,0,0, 0.4);
          position:relative;
          z-index:1000;
          width:51px;height:50px
        }"
      >
      <img src="@/pc/assets/icon/backtop.png" alt="" style="width:51px;height:50px;">
    </div>
    </el-backtop>
  </div>
  <div id="app" v-else>
    <commonHeaderH5></commonHeaderH5>
    <div class="main-content">
      <router-view/> <!-- 路由内容将在这里渲染 -->
    </div>
    <commonFooterH5></commonFooterH5>
    <el-backtop :bottom="70" :right="30" style="width:31px;height:30px;background: #fff;">
      <div
        style="{
          background-color: rgba(0,0,0, 0.4);
          position:relative;
          z-index:1000;
          width:31px;height:30px
        }"
      >
      <img src="@/mobile/assets/icon/backtop.png" alt="" style="width:31px;height:30px">
    </div>
    </el-backtop>
  </div>
</template>

<script>
import axios from "axios";
import { baseUrl } from '@/utils/env'
import commonHeaderPc from "@/pc/components/commonHeader/index.vue"
import commonFooterPc from "@/pc/components/commonFooter/index.vue"
import commonHeaderH5 from "@/mobile/components/commonHeader/index.vue"
import commonFooterH5 from "@/mobile/components/commonFooter/index.vue"

export default {
  name: 'App',
  components: {
    commonHeaderPc,
    commonFooterPc,
    commonHeaderH5,
    commonFooterH5
  },
  created() {
    this.getLocation()
  },  
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    }
  },
  methods:{
    // 获取地区
    getLocation () {
      const apiUrl = `${baseUrl}/api/common/getIP2Language`;
      axios.get(apiUrl).then(res => {
        var locale = ''
        if (localStorage.getItem("locale")) {
          locale = localStorage.getItem("locale")
        } else {
          if (res.data.data == 'cn' || res.data.data == 'zh') {
            localStorage.setItem("locale", 'zh')
            locale = 'zh'
          } else {
            localStorage.setItem("locale", 'en')
            locale = 'en'
          }
        }
        this.$i18n.locale = locale;
      })
      .catch(error => {
          
      });
    },
  }
}
</script>

<style>
.main-content{
  margin-top: 80px; 
}
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333; */
  /* margin-top: 60px; */
}
body {
  padding: 0;
  margin: 0;
}
</style>
